exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity[data-v-1830c7ce] {\n  padding-left: 0px;\n}\n", ""]);

// exports
